import { useRouter } from 'next/router';

// Note: To get a value, requires projectId to be in url. Ex: http://app.stably.ai/project/clikicjx10000zutdoz6lpfmm/
export function useProjectId() {
  const router = useRouter();
  const [, base, baseValue] = router.asPath.split('/');
  return base === 'project' ? baseValue : undefined;
}
